import { useState, useRef } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange, testId = "image-upload", label = "Immagine" }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File troppo grande (max 10MB).");
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Immagine caricata.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Upload fallito.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <span className="text-white/60 uppercase text-[10px] tracking-widest">{label}</span>
      <div className="mt-1 flex items-center gap-3">
        {value ? (
          <img src={value} alt="" className="w-16 h-16 object-cover border border-white/20" />
        ) : (
          <div className="w-16 h-16 border border-dashed border-white/20 flex items-center justify-center text-white/30 text-[10px] uppercase">Vuoto</div>
        )}
        <div className="flex-1 flex flex-col gap-2">
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            className="hidden"
            data-testid={`${testId}-input`}
            onChange={(e) => handleFile(e.target.files?.[0])}
          />
          <div className="flex gap-2">
            <button
              type="button"
              disabled={uploading}
              onClick={() => inputRef.current?.click()}
              data-testid={`${testId}-btn`}
              className="inline-flex items-center gap-2 border border-[color:var(--alien)] text-[color:var(--alien)] px-3 py-1.5 text-xs uppercase tracking-widest hover:bg-[color:var(--alien)] hover:text-black disabled:opacity-50"
            >
              {uploading ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />}
              {uploading ? "Carico…" : "Carica"}
            </button>
            {value && (
              <button
                type="button"
                onClick={() => onChange("")}
                data-testid={`${testId}-clear`}
                className="text-red-400 border border-red-400/40 px-3 py-1.5 text-xs uppercase tracking-widest"
              >
                Rimuovi
              </button>
            )}
          </div>
          <input
            type="text"
            placeholder="oppure incolla URL"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            data-testid={`${testId}-url`}
            className="w-full bg-transparent border border-white/20 px-3 py-1.5 text-xs text-white/80 focus:border-[color:var(--alien)] outline-none"
          />
        </div>
      </div>
    </div>
  );
};
